<script>
	import { getContext, onMount } from 'svelte';

	import { keyToken } from '../globals.js';
	import { formatAmount, formatPercent } from './formatting.js';

	const { getToken } = getContext(keyToken);
	const token = getToken();

	let assets = [];
	let hits = [];
	let search;

	async function loadAssetDetails() {
		if (!token) {
			console.warn('Not logged in!');
			return;
		}

		await fetch('https://ostium.ch/api/borsalino/get_assets.php', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8',
				'Authorization': 'JWT ' + encodeURIComponent(token)
			}
		}).then(result => {
			if (result.ok) {
				result.json().then(data => {
					console.log(`Loaded ${data.length} asset${data.length === 1 ? '' : 's'} for stock search.`);
					assets = data;
				});
			} else {
				console.warn('Could not load assets.', result.statusText);
			}
		});
	}

	function filterAssets(asset) {
		let term = search.toLowerCase();
		return asset.name.toLowerCase().includes(term)
			|| asset.symbol.toLowerCase().includes(term)
			|| asset.isin.toLowerCase().includes(term);
	}

	function highlightSearchTerm(asset) {
		let clone = Object.assign({}, asset);
		clone.nameFormatted = clone.name.replace(new RegExp(`(${search})`, 'gi'), '<strong class="text-warning">$1</strong>');
		clone.symbolFormatted = clone.symbol.replace(new RegExp(`(${search})`, 'gi'), '<strong class="text-warning">$1</strong>');
		clone.isinFormatted = clone.isin.replace(new RegExp(`(${search})`, 'gi'), '<strong class="text-warning">$1</strong>');
		return clone;
	}

	function doSearch() {
		if (search.length > 0) {
			hits = assets.filter(filterAssets).map(highlightSearchTerm);
		} else {
			hits = [];
		}
	}

	function clearSearchField() {
		search = '';
		hits = [];
	}

	onMount(() => {
		loadAssetDetails();
		jQuery('#search').on('blur', () => setTimeout(() => {
			hits = [];
		}, 200)); // Clear the hits with a delay to allow the asset dialog to open.
		jQuery('#search').on('focus', () => {
			if (search != null && search.length > 0) {
				doSearch();
			}
		});
	});
</script>

<style>
	.dropdown,
	.dropdown-menu {
		width: 32rem;
	}

	.dropdown-menu:empty,
	.dropdown-menu:-moz-only-whitespace {
		border: none;
	}

	.dropdown-item {
		display: inherit;
	}

	.col {
		padding-left: 0;
	}
	.col:last-child {
		padding-right: 0;
	}

	.row {
		margin-left: 0;
	}

	.row:hover .col {
		color: #343a40; /* text-dark */
	}

	.search-field {
		position: relative;
	}

	.search-field .form-control {
		display: inline-block;
	}

	.clear-search {
		position: absolute;
		right: .75rem;
		top: .75rem;
	}

	.clear-search:hover {
		color: rgba(0, 0, 0, .45) !important;
	}
</style>

<div class="dropdown">
	<div class="search-field">
		<input type="text" data-toggle="dropdown" class="form-control" id="search" placeholder="Search stocks, indices, symbol, ISIN, …" bind:value={search} on:input={doSearch} />
		<a href="." on:click|preventDefault={clearSearchField}><i class="fas fa-times-circle clear-search text-secondary"></i></a>
	</div>
	<div class="dropdown-menu container bg-tertiary" aria-labelledby="dropdownMenuLink">
		{#if hits.length > 0 && !hits[0].name.startsWith('^')}
		<h6 class="dropdown-header text-white-50">Stocks</h6>
		{/if}
		{#each hits as hit, index}
		{#if hits[index].name.startsWith('^') && (index === 0 || !hits[index - 1].name.startsWith('^'))}
		<h6 class="dropdown-header text-white-50">Indices</h6>
		{/if}
		<div class="dropdown-item row text-light" data-toggle="modal" data-target="#assetDetailsDialog" data-isin={hit.isin}>
			<div class="col">
				{@html hit.nameFormatted}<br>
				<small>{@html hit.symbolFormatted} / {@html hit.isinFormatted}</small>
			</div>
			<div class={'col text-right text-' + (hit.last < hit.close_day ? 'danger' : 'success')}>
				{hit.last > hit.close_day ? '+' : ''}{formatAmount((hit.last - hit.close_day) / hit.factor)}<br>
				<small>{formatPercent(hit.last / hit.close_day - 1.0)}</small>
			</div>
		</div>
		{/each}
  </div>
</div>
